import styled, { keyframes } from 'styled-components'
import theme from 'styles/theme'
import { space } from 'styled-system'
import LazyLoad from 'react-lazyload'
import { getBtnMainColor } from 'utils/themeUtils'
import videoPlayerUtils from './videoPlayerUtils'

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

export const PlaceholderImg = styled.div`
  position: absolute;
  opacity: 1;
  top: 0;
  width: 100%;
  height: 100%;

  img {
    filter: blur(8px);
  }

  &.hidden {
    opacity: 0;
    animation: ${fadeOut} 2s;
    animation-iteration-count: 1;
  }
`

export const Wrapper = styled.div`
  position: relative;
  display: block;
  position: relative;
  height: 100%;
  width: 100%;
  ${space}

  .video-js .vjs-dock-text,
  .vjs-big-play-button,
  .vjs-loading-spinner,
  .vjs-error-display {
    display: none;
  }

  .brightcove-react-player-loader {
    height: 100%;
    ${({ hasError }) => hasError && `opacity: 0`}
  }

  .video-js {

    .vjs-poster {
      display: none;
    }
  }

  .video-js .vjs-tech {
    width: auto;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .video-js .vjs-play-progress {
    background-color: ${getBtnMainColor()};
  }

  .video-js .vjs-slider {
    background-color: ${getBtnMainColor()};
  }

  .video-js {
    position: relative;
    object-fit: cover;
    object-position: center center;
    height: 100%;
    ${({ opacity }) => {
      // value from the cms can return undefined which should use playerDefault Opacity
      return `opacity: ${
        opacity === 0
          ? 0
          : opacity / 100 || videoPlayerUtils.videoPlayerlayerDefaultOpacity
      };`
    }}
    ${({ type }) => type === 'landscape' && `padding-top: 56.25%`}
    ${({ type }) => type === 'portrait' && `padding-top: 177.77%`}
  }

  .vjs-tech {
    ${({ opacity }) =>
      `opacity: ${
        opacity === 0
          ? 0
          : opacity / 100 || videoPlayerUtils.videoPlayerlayerDefaultOpacity
      };`}
  }

  .video-js.vjs-fluid:not(.vjs-audio-only-mode) {
    height: 100%;
    ${({ type }) => type === 'landscape' && `padding-top: 56.25%`}
    ${({ type }) => type === 'portrait' && `padding-top: 177.77%`}
  }

  .gatsby-image-wrapper {
    object-fit: cover;
    object-position: center center;
    width: 100%;
    max-width: none;
    height: 0;
    ${({ type }) => type === 'landscape' && `padding-top: 56.25%`}
    ${({ type }) => type === 'portrait' && `padding-top: 177.77%`}
  }

  .video-js .vjs-control-bar {
    ${({ controls }) => (!controls ? `display: none;` : ``)}
  }
`

export const Overlay = styled.div`
  background: rgba(69, 69, 69, 0.2);
  color: #fff;
  cursor: pointer;
  height: 0;
  left: 0;
  position: absolute;
  top: 0;
  transition: opacity 0.3s ease-in-out, display 0.3s ease-in-out;
  width: 100%;

  ${({ type }) => type === 'landscape' && `padding-top: 56.25%`}
  ${({ type }) => type === 'portrait' && `padding-top: 177.77%`}

  ${({ isPlaying }) =>
    isPlaying &&
    `
      opacity: 0;
      display: none;
  `}
`

export const PlayButton = styled.div`
  align-items: center;
  border-radius: 100%;
  bottom: 0;
  display: flex;
  height: 90px;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 90px;

  ${({ level }) => {
    const colors = {
      primary: {
        background: theme.colors.sage,
        color: theme.colors.white,
      },
      secondary: {
        background: theme.colors.alabaster,
        color: theme.colors.sage,
      },
      tertiary: {
        background: theme.colors.white,
        border: `1px solid ${theme.colors.alabaster}`,
        color: theme.colors.sage,
      },
    }

    return colors[level] || colors.primary
  }}
`

export const PlayButtonIco = styled.svg`
  display: block;
  height: 16px;
  overflow: visible;
  width: 16px;
`

export const PlayButtonArrow = styled.g`
  ${({ show }) =>
    show
      ? `
    transition: visibility 0s .3s;
    visibility: visible;
  `
      : `
    visibility: hidden;
  `}
`

export const PlayButtonReplay = styled.g`
  ${({ show }) =>
    !show &&
    `
    transition: visibility 0s .3s;
    visibility: hidden;
  `}
`

export const PlayButtonPath = styled.path`
  fill: ${getBtnMainColor()};
`

export const PlayButtonCircle = styled.circle`
  fill: none;
  stroke-dasharray: 38, 6;
  stroke-dashoffset: 55;
  stroke-width: 2px;
  stroke: ${getBtnMainColor()};
`

export const Divider = styled.span`
  display: inline-block;
  margin: 0 ${theme.space[1]};
  position: relative;
  top: -1px;
`

export const LazyLoadContainer = styled(LazyLoad)`
  height: 100%;
`
